
export enum EmailParticipantType {
  INCOMING = 'incoming',
  OUTGOING = 'outgoing'
}

export enum EmailConnectionStatus {
  ACTIVE = 'active',
  DISCONNECTED = 'disconnected',
  DISABLED = 'disabled',
  EXPIRED = 'expired'
}

export interface IEmailMessage {

}


export enum MailerTargetType {
  CONTACT = 'contact',
  CANDIDATE = 'candidate',
  APPLICANT = 'applicant',
}

export enum EmailSourceType {
  ENTITY_IDS = 'entity_ids',
  LIST = 'list',
}

/** Mail providers a user can directly connect (mirrors backend ConnectionProviderType). */
export enum EmailConnectionProvider {
  MICROSOFT = 'microsoft',
  GOOGLE = 'google',
}

/** "All time" maps to this many days (~10 years); mirrors backend MAX_BACKFILL_DAYS. */
export const MAX_BACKFILL_DAYS = 3650;

/** Options offered when a user connects a mailbox: how far back to pull history. */
export const EMAIL_BACKFILL_OPTIONS: { label: string; days: number }[] = [
  { label: "Don't import past emails", days: 0 },
  { label: 'Last 30 days', days: 30 },
  { label: 'Last 90 days', days: 90 },
  { label: 'Last 12 months', days: 365 },
  { label: 'All time', days: MAX_BACKFILL_DAYS },
];

export interface InitiateConnectionDto {
  provider: EmailConnectionProvider;
  backfill_days?: number;
}

export interface CompleteConnectionDto {
  code: string;
  /** One-time OAuth state nonce echoed back by the provider; resolves provider + backfill server-side. */
  state: string;
}

export interface EmailParticipant {
  email: string;
  name?: string;
}

export interface SendSingleMailDto {
  subject: string;
  to: string[];
  cc?: string[];
  bcc?: string[];
  body: string;
  target_type?: MailerTargetType;
  target_id?: string;
  attachments?: { file_id: string }[];
}

export interface SendMultiMailDto {
  email_source_type: EmailSourceType;
  entity_ids?: string[];
  entity_type?: MailerTargetType;
  list_id?: string;
  subject: string;
  body: string;
  template_id?: string;
  attachments?: { file_id: string }[];
}

export interface UpdateMailSettingsDto {
  signature?: string;
}

export enum EmailMessageTemplateType {
  CONTACT_ENGAGEMENT = 'contact_engagement',
  CANDIDATE_ENGAGEMENT = 'candidate_engagement',
  APPLICATION_UPDATE = 'application_update',
  OFFER_CONTENT = 'offer_content',
}

export enum EmailSendStatus {
  SENT = 'sent',
  FAILED = 'failed',
  PENDING = 'pending',
  DRAFT = 'draft',
  SCHEDULED = 'scheduled',
}

export enum TemplateVisibility {
  // can only create org-wide templates if the account is an org admin
  ORG_WIDE = 'org_wide',

  // can be created by any account, but only visible to the account that created it
  ACCOUNT_SPECIFIC = 'account_specific',
}

export type EmailMessageTemplate = {
  id: string;
  name: string;
  type: EmailMessageTemplateType;
  visibility: TemplateVisibility;
  subject: string;
  content: string;
  created_at: Date;
  updated_at: Date;
};

export type EmailActivity = {
  id: string;
  subject: string;
  content: string;
  created_at: Date;
  from: EmailParticipant;
  to: EmailParticipant[];
  cc: EmailParticipant[];
  bcc: EmailParticipant[];
  attachment_count: number;
  fail_reason?: string;
  status: EmailSendStatus;
}

export interface CreateMessageTemplateDto {
  name: string;
  type: EmailMessageTemplateType;
  visibility: TemplateVisibility;
  subject: string;
  content: string;
}

export const EntityTemplateVariables = {
  [EmailMessageTemplateType.CANDIDATE_ENGAGEMENT]: {
    candidate_first_name: '{{candidate_first_name}}',
    candidate_last_name: '{{candidate_last_name}}',
  },
  [EmailMessageTemplateType.CONTACT_ENGAGEMENT]: {
    contact_first_name: '{{contact_first_name}}',
    contact_last_name: '{{contact_last_name}}',
  },
  [EmailMessageTemplateType.APPLICATION_UPDATE]: {
    candidate_first_name: '{{candidate_first_name}}',
    candidate_last_name: '{{candidate_last_name}}',
    job_title: '{{job_title}}',
    job_consultant_first_name: '{{job_consultant_first_name}}',
    job_consultant_last_name: '{{job_consultant_last_name}}',
  },
  [EmailMessageTemplateType.OFFER_CONTENT]: {
    candidate_first_name: '{{candidate_first_name}}',
    candidate_last_name: '{{candidate_last_name}}',

    job_title: '{{job_title}}',
    employment_type: '{{employment_type}}',
    work_style: '{{work_style}}',
    job_consultant_first_name: '{{job_consultant_first_name}}',
    job_consultant_last_name: '{{job_consultant_last_name}}',

    employer_name: '{{employer_name}}',

    start_date: '{{start_date}}',
    end_date: '{{end_date}}',
    salary: '{{salary}}',
    rate_period: '{{rate_period}}',
    offer_information: '{{offer_details}}',

  },
}

